$(document).ready(function() {
    $('.collections-list').slick({
        dots: true,
        rows: 2,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
    {
        breakpoint: 1440,
        settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: false,
            dots: true
        }
        },
        {
        breakpoint: 1200,
        settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            dots: true
        }
        },
        {
        breakpoint: 999,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1
        }
        },
        {
        breakpoint: 640,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1
        }
        }
    ]
    });

    $('.customer-slider .customer-list').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    if ($(".tab_slider_main").length>0) {
  		$(".tab_slider_main").owlCarousel({
  			items : 5,
  			itemsCustom : false,
  			scrollPerPage: true,
  			loop: true,
  			slideSpeed: 500,
  			stopOnHover: true,
  			itemsDesktop : [1360,4],
  			itemsDesktopSmall : [991,3],
  			itemsTablet: [767,2],
  			itemsTabletSmall: false,
  			itemsMobile : [575,1],
  			itemsScaleUp : true,
  			pagination : false,
  			navigation : true,
  			navigationText : ["prev","next"],

  		});
  	}
});






// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
});


/* Extra class "tab_last"
   to add border to right side
   of last tab */
$('ul.tabs li').last().addClass("tab_last");
